import type {
  OrgLevelType,
  OrgNode,
  OrgNodeDetail,
  CreateOrgNodeInput,
  UpdateOrgNodeInput,
  AssignOrgDesignationInput,
  DataResponse,
} from '@pms/shared';
import { api } from '@/lib/api';

export const orgService = {
  async listLevelTypes(): Promise<OrgLevelType[]> {
    const res = await api.get<DataResponse<OrgLevelType[]>>('/org/level-types');
    return res.data.data;
  },

  async createLevelType(name: string): Promise<OrgLevelType> {
    const res = await api.post<DataResponse<OrgLevelType>>('/org/level-types', { name });
    return res.data.data;
  },

  async deleteLevelType(id: string): Promise<void> {
    await api.delete(`/org/level-types/${id}`);
  },

  async getTree(): Promise<OrgNode[]> {
    const res = await api.get<DataResponse<OrgNode[]>>('/org/nodes');
    return res.data.data;
  },

  async getNode(id: string): Promise<OrgNodeDetail> {
    const res = await api.get<DataResponse<OrgNodeDetail>>(`/org/nodes/${id}`);
    return res.data.data;
  },

  async createNode(input: CreateOrgNodeInput): Promise<{ id: string }> {
    const res = await api.post<DataResponse<{ id: string }>>('/org/nodes', input);
    return res.data.data;
  },

  async updateNode(id: string, input: UpdateOrgNodeInput): Promise<void> {
    await api.patch(`/org/nodes/${id}`, input);
  },

  async deleteNode(id: string): Promise<void> {
    await api.delete(`/org/nodes/${id}`);
  },

  async assignDesignation(nodeId: string, input: AssignOrgDesignationInput): Promise<void> {
    await api.post(`/org/nodes/${nodeId}/designations`, input);
  },

  async removeDesignation(nodeId: string, assignId: string): Promise<void> {
    await api.delete(`/org/nodes/${nodeId}/designations/${assignId}`);
  },
};
